import Vue from 'vue';
import i18n from './i18n'
import vuetify from './plugins/vuetify.plugin';

const userComp = new Vue({
  data() {
    return {
      user: null
    }
  },
  watch: {
    user(newValue, oldValue) {
      i18n.locale = newValue.language;
      vuetify.preset.lang.current = newValue.language;
    }
  },
});

export default userComp;
